// extracted by mini-css-extract-plugin
export default {"contentCard":"ContentCard_contentCard__a0Q4q"};